import { useTranslation } from "react-i18next";
const BigSidebar = ({
    menuToggle,
    sideContainer,
    menuToggleOnClickMobile,
    navigate,
    location,
    //isAllowedToViewNewContent,
    sideContainerRef,
    toggleButtonRef,
    setShowSmallPanel,
}) => {
    const { t } = useTranslation("menu");

    const displayComponentModerator = (
        <>
            <li
                className={
                    location.pathname.includes("/dashboard/moderation")
                        ? "MenuActive"
                        : "MenuActiveNo"
                }
                onClick={(e) => {
                    menuToggleOnClickMobile(e);
                    navigate("/dashboard/moderation");
                    setShowSmallPanel(true);
                }}
            >
                <img
                    src="/swordMod.svg"
                    alt="moderation"
                    onClick={(e) => {
                        menuToggleOnClickMobile(e);
                        navigate("/dashboard/moderation");
                        setShowSmallPanel(true);
                    }}
                    className="iconSizeMenu"
                />
                <span
                    className={
                        location.pathname.includes("/dashboard/moderation")
                            ? "activeLiSide"
                            : "notActiveSide"
                    }
                >
                    {t("sideMenuModeration")}
                </span>
            </li>
        </>
    );

    return (
        <>
            <div className="buttonContainerSidbar">
                <div className="menuButton" onClick={menuToggle}>
                    <img
                        src="/settingsIcon.svg"
                        alt="settings"
                        className="sideBarSettingsIcon"
                        ref={toggleButtonRef}
                    />
                </div>
            </div>
            <div
                style={sideContainer}
                className="sideContainerParent"
                ref={sideContainerRef}
            >
                <ul className="sideNavbarText">
                    <h3 className="sideNavbarBranding">
                        STREAM <span className="App-domain2">MEMES</span>
                    </h3>
                    <img
                        src="/logo.svg"
                        className="sideNavbarImage"
                        alt="logo"
                    />
                    <div className="sideNavbarTextContainer">
                        <li
                            className={
                                location.pathname.endsWith("/dashboard")
                                    ? "MenuActive"
                                    : "MenuActiveNo"
                            }
                            onClick={(e) => {
                                menuToggleOnClickMobile(e);
                                navigate("/dashboard");
                                setShowSmallPanel(true);
                            }}
                        >
                            <img
                                src="/apps.svg"
                                alt="apps"
                                onClick={(e) => {
                                    menuToggleOnClickMobile(e);
                                    navigate("/dashboard");
                                    setShowSmallPanel(true);
                                }}
                                className="iconSizeMenu"
                            />
                            <span
                                className={
                                    location.pathname.endsWith("/dashboard")
                                        ? "activeLiSide"
                                        : "notActiveSide"
                                }
                            >
                                {t("sideMenuDashboard")}
                            </span>
                        </li>
                        <li
                            className={
                                location.pathname.includes(
                                    "/dashboard/templates",
                                )
                                    ? "MenuActive"
                                    : "MenuActiveNo"
                            }
                            onClick={(e) => {
                                menuToggleOnClickMobile(e);
                                navigate("/dashboard/templates");
                                setShowSmallPanel(true);
                            }}
                        >
                            <img
                                src="/book-alt.svg"
                                alt="book"
                                onClick={(e) => {
                                    menuToggleOnClickMobile(e);
                                    navigate("/dashboard/templates");
                                    setShowSmallPanel(true);
                                }}
                                className="iconSizeMenu"
                            />
                            <span
                                className={
                                    location.pathname.includes(
                                        "/dashboard/templates",
                                    )
                                        ? "activeLiSide"
                                        : "notActiveSide"
                                }
                            >
                                {t("sideMenuMemeTemplateLibarary")}
                            </span>
                        </li>
                        <li
                            className={
                                location.pathname.includes("/dashboard/filters")
                                    ? "MenuActive"
                                    : "MenuActiveNo"
                            }
                            onClick={(e) => {
                                menuToggleOnClickMobile(e);
                                navigate("/dashboard/filters");
                                setShowSmallPanel(true);
                            }}
                        >
                            <img
                                src="/document.svg"
                                alt="filter"
                                onClick={(e) => {
                                    menuToggleOnClickMobile(e);
                                    navigate("/dashboard/filters");
                                    setShowSmallPanel(true);
                                }}
                                className="iconSizeMenu"
                            />
                            <span
                                className={
                                    location.pathname.includes(
                                        "/dashboard/filters",
                                    )
                                        ? "activeLiSide"
                                        : "notActiveSide"
                                }
                            >
                                {t("sideMenuProfanityFilters")}
                            </span>
                        </li>
                        {displayComponentModerator}
                        <li
                            className={
                                location.pathname.includes(
                                    "/dashboard/settings",
                                )
                                    ? "MenuActive"
                                    : "MenuActiveNo"
                            }
                            onClick={(e) => {
                                menuToggleOnClickMobile(e);
                                navigate("/dashboard/settings");
                                setShowSmallPanel(true);
                            }}
                        >
                            <img
                                src="/flower.svg"
                                alt="book"
                                onClick={(e) => {
                                    menuToggleOnClickMobile(e);
                                    navigate("/dashboard/settings");
                                    setShowSmallPanel(true);
                                }}
                                className="iconSizeMenu"
                            />
                            <span
                                className={
                                    location.pathname.includes(
                                        "/dashboard/settings",
                                    )
                                        ? "activeLiSide"
                                        : "notActiveSide"
                                }
                            >
                                {t("sideMenuSettings")}
                            </span>
                        </li>
                        <li
                            className={
                                location.pathname.includes("/dashboard/help")
                                    ? "MenuActive"
                                    : "MenuActiveNo"
                            }
                            onClick={(e) => {
                                menuToggleOnClickMobile(e);
                                navigate("/dashboard/help");
                                setShowSmallPanel(true);
                            }}
                        >
                            <img
                                src="/interrogation.svg"
                                alt="help"
                                onClick={(e) => {
                                    menuToggleOnClickMobile(e);
                                    navigate("/dashboard/help");
                                    setShowSmallPanel(true);
                                }}
                                className="iconSizeMenu"
                            />
                            <span
                                className={
                                    location.pathname.includes(
                                        "/dashboard/help",
                                    )
                                        ? "activeLiSide"
                                        : "notActiveSide"
                                }
                            >
                                {t("sideMenuHelp")}
                            </span>
                        </li>
                        <li
                            className={
                                location.pathname.includes("/dashboard/Logout")
                                    ? "MenuActive"
                                    : "MenuActiveNo"
                            }
                            onClick={() => {
                                navigate("/");
                            }}
                        >
                            <img
                                alt="logout"
                                src="/logoutButton.png"
                                id="logoutButtonSideMenu"
                                onClick={() => navigate("/")}
                                className="iconSizeMenu"
                            />
                            <span
                                className={
                                    location.pathname.includes(
                                        "/dashboard/loggout",
                                    )
                                        ? "activeLiSide"
                                        : "notActiveSide"
                                }
                            >
                                {t("sideMenuLogout")}
                            </span>
                        </li>
                    </div>
                </ul>
            </div>
        </>
    );
};

export default BigSidebar;
